/**
 * Slider Actions Constant
 */
export const TOGGLE_CANCEL_DATATABLE_SLIDER = 'CANCEL';
export const TOGGLE_CLOSE_DATATABLE_SLIDER = 'CLOSE';
export const TOGGLE_TEST_ARG_SLIDER = 'TOGGLE_TEST_ARG_SLIDER';
export const TOGGLE_RUN_SET_ARG_SLIDER = 'TOGGLE_RUN_SET_ARG_SLIDER';
export const TOGGLE_RUN_SET_DETAIL_SLIDER = 'TOGGLE_RUN_SET_DETAIL_SLIDER';
export const TOGGLE_EXECUTION_SLIDER = 'TOGGLE_EXECUTION_SLIDER';
export const TOGGLE_PROFILE_SETUP_SLIDER = 'TOGGLE_PROFILE_SETUP_SLIDER';
export const TOGGLE_TEST_STEP_SLIDER = 'TOGGLE_TEST_STEP_SLIDER';
export const TOGGLE_ADD_ORG_USER_SLIDER = 'TOGGLE_ADD_ORG_USER_SLIDER';
export const TOGGLE_APP_KEY_SLIDER = 'TOGGLE_APP_KEY_SLIDER';
export const TOGGLE_SYSTEM_SETTING_SLIDER = 'TOGGLE_SYSTEM_SETTING_SLIDER';
export const TOGGLE_USER_CREDENTIAL_SLIDER = 'TOGGLE_USER_CREDENTIAL_SLIDER';
